import { useEffect, useState } from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';
import { mapStyles } from './mapStyles';
import { CustomInfoWindow } from './customInfoWindow';
import { ILocation } from '../../models/index';
import AddCircleIcon from '../../images/svg';

interface Props {
  officeLocations: ILocation[];
  searchAddress: string;
  nearestOffice: ILocation | null;
  isMapLoaded: () => void;
}

export const Map = withScriptjs(
  withGoogleMap((props: Props) => {
    const [infoWindowOpen, setInfoWindowOpen] = useState<number | null>();

    const handleToggleOpen = (markerId: number | null) => {
      setInfoWindowOpen(markerId);
    };

    useEffect(() => {
      if (props.nearestOffice !== null) {
        setCenter({
          lat: props.nearestOffice.lat,
          lng: props.nearestOffice.lng,
        });
      }
    }, [props.nearestOffice]);

    useEffect(() => {
      !props.nearestOffice && handleToggleOpen(null);
      props.nearestOffice && handleToggleOpen(props.nearestOffice.id);
    }, [props.nearestOffice]);

    const [center, setCenter] = useState({ lat: 27.949, lng: -82.75 });
    return (
      <GoogleMap
        onTilesLoaded={() => {
          props.isMapLoaded();
        }}
        options={{
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          zoomControl: false,
          styles: mapStyles,
          gestureHandling: 'greedy',
        }}
        zoom={11}
        center={center}
      >
        <>
          {props.officeLocations.map((location) => {
            return (
              <Marker
                icon={AddCircleIcon}
                key={location.id}
                position={{ lat: location.lat, lng: location.lng }}
                onClick={() => {
                  setInfoWindowOpen(location.id);
                  setCenter({ lat: location.lat, lng: location.lng });
                }}
              >
                <CustomInfoWindow
                  key={location.id}
                  title={location.name}
                  address={location.address}
                  lat={location.lat}
                  isShown={infoWindowOpen === location.id}
                  lng={location.lng}
                  onClick={() => {
                    setInfoWindowOpen(null);
                  }}
                />
              </Marker>
            );
          })}
        </>
      </GoogleMap>
    );
  })
);
